// ============================================
// Main Entry Point for Lane Shooter Game
// TypeScript Edition - P5.js Instance Mode
// ============================================

import type p5 from 'p5';
import { setP5Instance } from './p5-instance';
import { setup } from './setup';
import { draw } from '../engine/loop/main-loop';
import { keyPressed, mousePressed, touchStarted } from '../engine/input/input';

// P5.jsの初期化関数
function initGame() {
    // グローバルのp5（CDNから読み込まれたもの）を使用
    const p5Constructor = (window as unknown as { p5: new (sketch: (p: p5) => void) => p5 }).p5;

    if (!p5Constructor) {
        console.error('❌ P5.js not loaded. Make sure p5.js is loaded before bundle.js');
        return;
    }

    // P5.js インスタンスモードで初期化
    new p5Constructor((p: p5) => {
        // P5インスタンスをグローバルに保存
        setP5Instance(p);

        // P5.jsライフサイクル関数を設定
        // p5.jsの型定義ではsetupなどは読み取り専用扱いになる場合があるため、
        // インスタンスモードの代入にはプロパティアクセスを使用
        const pAsUnknown = p as unknown as Record<string, unknown>;
        pAsUnknown.setup = () => {
            setup(p);
        };

        pAsUnknown.draw = () => {
            draw(p);
        };

        pAsUnknown.keyPressed = () => {
            return keyPressed(p);
        };

        pAsUnknown.mousePressed = () => {
            mousePressed(p);
        };

        pAsUnknown.touchStarted = () => {
            return touchStarted(p);
        };
    });

    // Log module system initialization
    console.log('🚀 Lane Shooter - Module System Initialized (TypeScript + P5 Instance Mode)');
    console.log('📦 All modules loaded successfully');
}

// DOMが読み込まれた後にP5.jsを初期化
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGame);
} else {
    // DOMが既に読み込まれている場合は即座に実行
    initGame();
}
